// extracted by extract-css-chunks-webpack-plugin
module.exports = {"BaseHeading":"CategoryHeading__BaseHeading__3XonC","CategoryHeading":"CategoryHeading__CategoryHeading__2w5Jl"};